<template>
  <section class="healthy-warning">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="tips"
      @load="getList"
    >
      <!--  -->

      <van-swipe-cell v-for="(item,index) in list" :key="index" class="unresolve">
        <van-cell-group>
          <div class="sy-cell sosItem" @click="gosos(item)">
            <img v-lazy="item.headUrl" class="images">
            <div class="content">
              <div class="user">
                <div class="sy-cell_between">

                  <div class="user-name">
                    {{ item.name }}
                  </div>
                  <div class="time">
                    {{ format(new Date(item.testTime)).slice(10,16) }}
                  </div>
                </div>
                <p class="main">
                  {{ item.addr }}
                </p>
                <div class="sy-cell latlng">
                  {{ $t('viewBase.a82') }}:{{ item.lng }}&nbsp;{{ $t('viewBase.a83') }}:{{ item.lat }}
                </div>
              </div>
            </div>
          </div>
        </van-cell-group>
        <!-- <div v-if="!params.ishandle" slot="right" style="width: 65px" class="handle" @click="onOpen(item.Id)">
          处理
        </div> -->
      </van-swipe-cell>
    </van-list>
  </section>
</template>
<script>
import { healthSos } from '@/api/health-sos'
import { dateFormat } from '../../utils/tool.js'
import { getAccountId } from '@/utils/auth'
export default {
  name: 'HealthyWarning',
  data() {
    return {
      loading: false,
      finished: false,
      tips: '',
      list: [],
      active: 0,
      rightWidth: 65,
      params: {
        page: 1,
        row: 20,
        accountId: getAccountId()
      },
      show: false,
      value: '',
      format: dateFormat
    }
  },
  created() {

  },
  methods: {
    async getList() {
      // this.params.accountId = this.$route.query.id
      try {
        const res = await healthSos(this.params)
        const list = res.data.data
        if (this.params.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        this.loading = false
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
        this.finished = list.length < 20
        this.params.page++
      } catch (error) {
        console.log(error)
      }
    },
    // 删除
    onClose(instance) {
      console.log(instance)
    },
    onOpen(id) {
      this.param.WarnDataId = id
      this.show = true
      this.param.Handle = ''
      this.param.Descript = ''
    },
    // delectItem() {
    //   // if(!this.param.Handle || !this.param.Descript){
    //   //    this.$toast({
    //   //     message: '请确认姓名和意见是否全部填写',
    //   //     duration: 1500
    //   //   })
    //   //   return false
    //   // }
    //   delectHealthSos(this.param).then(res => {
    //     this.params.page = 1
    //     this.getList()
    //     this.show = false
    //   })
    // },
    gosos(id) {
      console.log(id)
      this.$router.push({ name: 'friendSos', params: id })

      // delectHealthSos({ accountId: id.accountId }).then(() => {
      // }).catch(() => {
      //   // this.$router.push({ name: 'friendSos', params: id })
      // })
    }
  }
}
</script>
<style scoped lang="scss">
.unresolve {
  .van-swipe-cell__right {
    color: #fff;
    font-size: 15px;
    width: 65px;
    height: 80px;
    display: inline-block;
    text-align: center;
    line-height: 80px;
    background-color: #f44;
  }
  .van-swipe-cell__left {
    color: #fff;
    font-size: 15px;
    width: 65px;
    height: 88px;
    display: inline-block;
    text-align: center;
    line-height: 88px;
    background-color: #0066ff;
  }
}
.sosItem{
  width: 100%;
  padding:8px 12px 10px;
  // display: flex;
  // align-items: center;
  // justify-content: flex-start;
  box-sizing: border-box;
  .content{
    width: 100%;
    display: flex;
    justify-content: space-between;
    .user,.time{
      width: 100%;
    }
    p{
      text-align: left;
      color:#333;
      font-size:14px;
      margin:5px 0 0;
    }
    .main{
       font-size: 12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:16px;
    }
    .user-name{
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:22px;
    }
    .time{
      width: 20%;
      color:#999;
      font-size: 12px;
      text-align: right;
    }
    .latlng{
      width: 300px;
      font-size:11px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:15px;
      margin-top:6px;
    }
  }

}
.images{
  width:44px;
  height:44px;
  border-radius: 50%;
 margin-right:10px;
 flex:none;
}
.text{
  width:80%;
  border:1px solid #999;
  border-radius: 10px;
  height:auto;
  padding:15px;
  margin:15px auto;
}
.text1{
  padding:5px;
}
.handle {
    background: #ccc;
    color: #fff;
    text-align: center;
    // line-height: 81px;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>

